(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });
  document.addEventListener('DOMContentLoaded', function () {
    const header = document.querySelector('store-header');
    const btn = document.getElementById('search-toggle');
    const mainDisclosure = header && header.querySelector('.main-menu__disclosure');

    if (header) {
      header.addEventListener('click', function (event) {
        const link = event.target.closest('a[href]');

        if (!link || !header.contains(link)) return;

        const href = link.getAttribute('href');

        if (!href || href === '#') return;

        let navUrl = link.href;

        try {
          const parsedUrl = new URL(link.href, window.location.origin);
          navUrl = parsedUrl.origin === window.location.origin
            ? `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`
            : parsedUrl.href;
        } catch (error) {
          navUrl = href;
        }

        const navTextSource = (
          link.dataset.navText ||
          link.getAttribute('aria-label') ||
          link.innerText ||
          link.textContent ||
          ''
        ).trim().replace(/\s+/g, ' ');
        const navText = navTextSource || (
          link.querySelector('img')?.getAttribute('alt') ||
          ''
        ).trim().replace(/\s+/g, ' ');

        const navClickData = {
          nav_location: 'header',
          nav_text: navText || 'header_link',
          nav_url: navUrl
        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'nav_click',
          ...navClickData
        });

        if (typeof window.gtag === 'function') {
          window.gtag('event', 'nav_click', navClickData);
        }
      });
    }

    const syncMobileMenuState = function () {
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      const isOpen = mainDisclosure && mainDisclosure.classList.contains('is-open');
      const shouldLockHeader = Boolean(isMobile && isOpen);

      document.body.classList.toggle('header-menu-is-open', shouldLockHeader);

      if (shouldLockHeader && header) {
        document.documentElement.style.setProperty('--mobile-menu-offset', `${header.getBoundingClientRect().height}px`);
      } else {
        document.documentElement.style.removeProperty('--mobile-menu-offset');
      }
    };

    if (mainDisclosure) {
      new MutationObserver(syncMobileMenuState).observe(mainDisclosure, {
        attributes: true,
        attributeFilter: ['class', 'open']
      });
      window.addEventListener('resize', syncMobileMenuState);
      syncMobileMenuState();
    }

    if (!header || !btn) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const isOpen = header.classList.toggle('search-open');
      btn.setAttribute('aria-expanded', String(isOpen));
      if (isOpen) {
        const input = header.querySelector('.header__search input[type="search"], .header__search input');
        input && input.focus();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spin-to-win-klaviyo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const markKlaviyoShells = () => {
      document.querySelectorAll('[data-spin-klaviyo-shell]').forEach((shell) => {
        const formHost = shell.querySelector('[class*="klaviyo-form-"]');
        const visibleHostHeight = formHost ? formHost.getBoundingClientRect().height : 0;
        const hasRenderedForm = formHost && (formHost.children.length > 0 || visibleHostHeight > 80);
        const hasIframe = !!shell.querySelector('iframe');
        const hasForm = !!shell.querySelector('form');
        const hasInputs = !!shell.querySelector('input, button, [role="button"]');

        shell.classList.toggle('is-loaded', Boolean(hasRenderedForm || hasIframe || hasForm || hasInputs));
      });
    };

    const observer = new MutationObserver(markKlaviyoShells);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('DOMContentLoaded', markKlaviyoShells);
    window.addEventListener('load', markKlaviyoShells);
    window.setTimeout(markKlaviyoShells, 1200);
    window.setTimeout(markKlaviyoShells, 3000);
    markKlaviyoShells();
  })();

  } catch(e) { console.error(e); }
})();
})();
